// extracted by mini-css-extract-plugin
module.exports = {"container":"AdBanner_container__uOXs3","adSlot":"AdBanner_adSlot__8f4Uk"};